module.exports = __webpack_public_path__ + "static/media/receipt.f089ee9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/receipt.svg
// module id = 1227
// module chunks = 0